import ApiService from './apiService';

class NoticationsService  {
    // Récupérer les notifications de l'utilisateur
     getUserNotifications(params = {}) {
        const defaultParams = {
            page: params.page || 1,
            perPage: params.perPage || 15,
            unread: params.unread || false
        };

        return ApiService.get(`/notifications`, {
            params: defaultParams
        })
    }

    // Récupérer le nombre de notifications non lues
    getUnreadCount() {
        return ApiService.get(`/notifications/unread-count`)
    }

    // Marquer une notification comme lue
    markAsRead(notificationId) {
        return ApiService.post(`/notifications/mark-as-read/${notificationId}`)
    }

    // Marquer toutes les notifications comme lues
    markAllAsRead() {
        return ApiService.post(`/notifications/mark-all-as-read`)
    }

    // Supprimer une notification
    deleteNotification(notificationId) {
        return ApiService.delete(`/notifications/${notificationId}`)
    }

    // Envoyer une notification (nécessite des privilèges)
    sendNotification(data) {
        return ApiService.post(`/notifications/send`, data)
    }
}

export default new NoticationsService();